module.exports = __webpack_public_path__ + "static/media/modalImg3.0042fdf4.png";